import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import WSChat from 'components/chat/WSChat';
import Footer from 'components/no-auth/footer/Footer';
import BasePageForNoAuth from 'components/utils/BasePageForNoAuth';
import MessageBodyService from 'components/utils/MessageBodyService';

import { CHAT_ZENDESK } from 'constants/UrlConstants';

import { removeScript } from 'helpers/DOM';

import PromoSpinner from './common/PromoSpinner/PromoSpinner';
import StrapiHeader from './header/StrapiHeader';
import Popup from '../common/Popup/Popup';
import NotFound from '../NotFound';

const useZendeskChat = (isShowNavModal, renderOptions = {}) => {
    useEffect(() => {
        const addChat = () => {
            if (__isBrowser__) {
                const script = document.createElement('script');
                script.src = CHAT_ZENDESK;
                script.id = 'ze-snippet';
                document.body.appendChild(script);
            }
        };
        if (__isBrowser__ && renderOptions?.isBusinessConnect && !isShowNavModal) {
            if (document.readyState === 'complete') {
                addChat();
            } else {
                window.addEventListener('load', addChat, { once: true });
            }
        }
        return () => {
            if (renderOptions?.isBusinessConnect && !isShowNavModal) {
                removeScript(CHAT_ZENDESK);
            }
        };
    }, [renderOptions?.isBusinessConnect, isShowNavModal]);
};

export default function NotAuthBasePage(PageComponent) {
    const ComposedComponent = (props) => {
        const lang = props.noAuthFooter?.language?.lang ? props.noAuthFooter.language.lang : props.backendLang;
        const country = props.noAuthFooter?.language?.country ? props.noAuthFooter.language.country : props.backendCountry;
        const renderOptions = props.renderOptions;

        useZendeskChat(props.isShowNavModal, renderOptions);

        const renderChat = () => {
            if (
                renderOptions?.isGlobalAccount ||
                renderOptions?.isBusinessConnect ||
                renderOptions?.isGrow ||
                renderOptions?.isApplePay ||
                renderOptions?.isHelpMobile
            ) {
                return null;
            }

            return <WSChat />;
        };

        if (props.notFound) {
            return <NotFound />;
        }

        return (
            <>
                {!props.loading && !renderOptions?.isHelpMobile && Array.isArray(props.newMenuObject) && props.newMenuObject.length > 0 && (
                    <StrapiHeader
                        loading={props.loading}
                        isShowNavModal={props.isShowNavModal}
                        menuSection={props.stateOptions?.menuSection}
                        data={props.newMenuObject}
                        pageName={props.stateOptions?.pageName}
                        libre={props.renderOptions?.isLibre}
                    />
                )}
                <main id="content" className={props.loading ? 'lock_container' : ''} style={{ opacity: `${props.loading ? '0.3' : '1'}` }}>
                    {!props.loading && <PageComponent {...props} data={props.data} loading={props.loading} renderOptions={renderOptions} />}
                </main>
                <PromoSpinner forceShow={props.loading} />
                {!props.loading && !renderOptions?.isHelpMobile && (
                    <Footer renderOptions={renderOptions} data={props.noAuthFooter} lang={lang} country={country} isLanding={false} />
                )}
                {renderChat()}
                <MessageBodyService />
                <Popup />
                {props.isShowModal && props.modalComponent}
            </>
        );
    };

    const mapStateToProps = (state) => {
        return {
            noAuthFooter: state.extra.noAuthFooter,
            notFound: state.extra.notFound,
            isShowNavModal: state.app.isShowNavModal,
            modalComponent: state.app.modalComponent,
            isShowModal: state.app.isShowModal,
            lang: state.extra.noAuthFooter?.language?.lang,
            country: state.extra.noAuthFooter?.language?.country,
            newMenuObject: state.extra.newNoAuthMenu?.header,
        };
    };
    return connect(mapStateToProps)(BasePageForNoAuth(ComposedComponent));
}
